var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagType,_vm._g(_vm._b({tag:"component",class:`cv-skip-to-content ${_vm.carbonPrefix}--skip-to-content`},'component',_vm.linkProps,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v("Skip to main content")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }